import { FaEye, FaGithub } from "react-icons/fa";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { useEffect, useState } from "react";
import { storage } from "../firebase";
import { ref, getDownloadURL } from "firebase/storage";
import { IoMdPlay } from "react-icons/io";

export default function ProjectCard({ data }) {
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    if (data.image)
      getDownloadURL(ref(storage, `images/${data.image}.png`)).then((url) => {
        setImageUrl(url);
      });
  }, [data]);

  return (
    <AnimationOnScroll animateIn="animate__fadeInRight" className="w-full">
      <div className="flex flex-col w-full p-3 mb-6 md:flex-row md:h-60 bg-color2">
        <div className="flex items-center justify-center flex-shrink-0 w-full h-56 overflow-hidden md:w-80 lg:w-96 md:h-auto">
          <img className="min-w-full min-h-full" src={imageUrl} alt="" />
        </div>
        <div className="flex flex-col flex-1 mt-4 md:mt-0 md:ml-4">
          <h4 className="mb-2 text-3xl font-semibold ">{data.title}</h4>
          <p className="overflow-hidden text-lg">{data.description}</p>

          {/* butons */}
          <div className="flex mt-4 md:mt-auto">
            {data.demo && (
              <a
                rel="noreferrer"
                href={data.demo.url}
                target="_blank"
                className="flex items-center px-4 py-1 mr-4 text-black button bg-color3"
              >
                {!!data.demo.hosted ? (
                  <FaEye className="inline mr-2 " />
                ) : (
                  <IoMdPlay className="inline mr-2 " />
                )}
                <p>Demo</p>
              </a>
            )}
            {data.sourceCode && (
              <a
                rel="noreferrer"
                href={data.github}
                target="_blank"
                className="flex items-center px-4 py-1 mr-4 text-black bg-white button"
              >
                <FaGithub className="inline mr-2" />
                <p>GitHub</p>
              </a>
            )}
          </div>
        </div>
      </div>
    </AnimationOnScroll>
  );
}
